module.exports = require('./browser/algorithms.json')



//////////////////
// WEBPACK FOOTER
// ./~/browserify-sign/algos.js
// module id = 388
// module chunks = 38